import aiManagenent from "src/locales/zh-CN/aiManagenent";
import installation from "src/locales/zh-CN/installation";
import userManagement from "src/locales/zh-CN/userManagement";
import common from "../locales/zh-CN/common";
import home from "../locales/zh-CN/home";
import layout from "../locales/zh-CN/layout";
import license from "../locales/zh-CN/license";
import company from "./zh-CN/company";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  ...common,
  ...layout,
  ...company,
  ...home,
  ...license,
  ...installation,
  ...userManagement,
  ...aiManagenent,
};
